<script setup>
const props = defineProps({
  image: {
    type: Object,
    required: true,
  },
  productTitle: {
    type: String,
    required: true,
  },
  badges: {
    type: Array,
    default: () => [],
  },
})
</script>

<template>
  <div class="slide">
    <ProductImage
      :image="image"
      :sold-out="props.image.soldOut"
      :product-title="props.productTitle"
      :pre-order="props.image.preOrder"
      :lazy="false"
      :preload="{ fetchPriority: 'high' }"
      :badges="props.badges"
      sizes="sm:540px md:760px lg:495 xl:775px"
      :placeholder="false"
    />
  </div>
</template>

<style lang="scss" scoped>
.slide {
  height: 100%;
  width: 100%;
}
</style>
